import React, { Component } from 'react';
import './notfound.style.css';

const NotFound = (props) => {

    return (
        < div className="not-found-wrap" >
            <div className="not-found-cover">
            </div>

            <div className="not-found-404">404
            </div>
            <div>ไม่พบหน้าที่คุณค้นหา</div>
            <a href="/c/"><div className="not-found-home">กลับหน้าหลัก</div></a>
        </div >
    )
}

export { NotFound }
